import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=63f76eb2&scoped=true&lang=html&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f76eb2",
  null
  
)

export default component.exports